import { CompanyCanceledContractList } from "@/features/company/pages/CompanyCanceledContractList";
import { FC } from "react";

const CompanyCanceledContractListPage: FC = () => {
  return <CompanyCanceledContractList />;
};

export default CompanyCanceledContractListPage;
